export enum AgoraClientModes {
    Rtc = 'rtc',
    Live = 'live'
}